import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-top_10_nova_icon_7",
  "use": "icon-top_10_nova_icon_7-usage",
  "viewBox": "0 0 243 336",
  "content": "<symbol viewBox=\"0 0 243 336\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-top_10_nova_icon_7\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M243 0V45.648L117.502 336H29.6037L151.697 68.7252H0V0H243ZM167.149 58.7886L45.0563 326.063H110.982L233.075 43.5902V9.93658H9.92475V58.7886H167.149Z\" fill=\"#656666\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol